<template>
<div>
    <b-modal id="slots-modal" title="Paytable" size="lg" v-model="isShown" @hidden="onClose" :hide-footer="true" scrollable>
        <template v-slot:modal-header>
            <div class="tab-controls d-flex flex-column">
                <div class="control d-flex justify-content-center" @click="context = 'settings'" :class="[{'active':context == 'settings'}]">
                    <span class="align-self-center"><fa-icon icon="cogs"></fa-icon></span>
                </div>
                <div class="control d-flex justify-content-center"  @click="context = 'tutorial'" :class="[{'active':context == 'tutorial'}]">
                    <span class="align-self-center"><fa-icon icon="info"></fa-icon></span>
                </div>
                <div class="control d-flex justify-content-center" @click="context = 'history'" :class="[{'active':context == 'history'}]">
                    <span class="align-self-center"><fa-icon icon="history"></fa-icon></span>
                </div>
              <div class="control d-flex justify-content-center" @click="goHome" v-if="homeLink">
                <span class="align-self-center"><fa-icon icon="home"></fa-icon></span>
              </div>
                <div class="control d-flex justify-content-center" @click="$bvModal.hide('slots-modal')">
                    <span class="align-self-center"><fa-icon icon="window-close"></fa-icon></span>
                </div>
                
            </div>
        </template>
        <div>
            <settings v-if="context == 'settings'"></settings>
            <tutorial v-else-if="context == 'tutorial'"></tutorial>
            <history v-else-if="context == 'history'"></history>
        </div>
    </b-modal>
</div>
</template>

<script>
import History from './History';
import Tutorial from './Tutorial';
import Settings from './Settings';

export default {
    components: { History, Tutorial, Settings },

    props: ['startingContext', 'show'],

    data() {
        return {
            isShown: false,
            isHistoryActive: false,
            context: this.startingContext,
            gameName: Config.game_name.toLowerCase(),
            homeLink: Config.home_url,
        }
    },

    methods: {
        activateHistory() {
            this.isHistoryActive = true;
        },

        onClose() {
            this.isHistoryActive = false;
            this.$emit('hidden');
        },

        goHome() {
          if (window.parent) {
            window.open(this.homeLink, '_top');
          } else {
            window.location = this.homeLink;
          }
        },
    },
    watch: {
        show(value) {
            if (value) {
                this.isShown = true;
            }
        },
        startingContext(value) {
            this.context = value;
        },
    },
}
</script>